module.exports = "<!--timeframe dropdown on audit tab -->\n<div class=\"dbmTimeFrame\">\n    <div class=\"form-group\">\n        <div class=\"input-report-title\">\n            <span class=\"title\">Time Frame</span>\n        </div>\n        <div class=\"input-wrapper\">\n            <mat-select class=\"time-frame-btn btn btn-drop-down\" [(ngModel)]=\"selectedTime\">\n                <mat-option *ngFor=\"let item of times\" [value]=\"item\">{{item.name}}</mat-option>\n            </mat-select>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dbm-components/dbm-timeframe/dbm-timeframe.component.html
// module id = 1891
// module chunks = 0